import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/common/ajax.js'
import addMenuRouter from '@/common/addMenuRouter'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    FunctionPermissions: [],//功能权限
    Menu: [], //系统菜单
    IsCollapse: false,
    InternalCode: [], //数据字典
    UserNameInfo: [],
  },
  getters: {
    getInternalCodeByCodeType: state => CodeTypeID => {
      if (!CodeTypeID) {
        return []
      }
      return state.InternalCode.filter(
        (r) => r.CodeType == CodeTypeID && r.IsDelete == 0
      ).sort();
    },

  },
  mutations: {
    setFunctionPermissions(state, list) {
      state.FunctionPermissions = list
    },
    setMenu(state, tree) {
      state.Menu = tree
    },
    changeCollapse(state) {
      state.IsCollapse = !state.IsCollapse;
    },

    initInternalCode(state, list) {
      state.InternalCode = list;
    },
    initDetectStation(state, list) {
      state.DetectStation = list;
    },
    initUserNameInfo(state, list) {
      state.UserNameInfo = list;
    },
  },
  actions: {
    initUserInfo(context) {
      http.get('Power/GetPowerByUser').then(res => {
        let Result = res.Result;
        //功能权限
        let functionPermissions = Result.filter(r => r.PowerKind == "3").map(r => r.PowerCode)
        context.commit('setFunctionPermissions', functionPermissions);
        //添加菜单
        let list = Result.filter(r => r.PowerKind == '1' || r.PowerKind == '2').map(r => {
          return {
            id: r.PowerId,
            parentId: r.PowerParent,
            kind: r.PowerKind,
            code: r.PowerCode,
            title: r.PowerName,
            component: r.PowerUrl,
            icon: r.PowerIcon
          }
        })
        addMenuRouter(list);
      })
    },
    initInternalCode(context) {
      http.get('Common/GetInternalCode').then(res => {
        context.commit('initInternalCode', res.Result)
      });
    },
    initDetectStation(context) {
      http.get('Common/GetOrgStation').then(res => {
        context.commit('initDetectStation', res.Result)
      });
    },
    initUserNameInfo(context) {
      http.get('User/GetOrgUserList').then(res => {
        context.commit('initUserNameInfo', res.Result)
      });
    },
  },
  modules: {
  }
})
